var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2579_7179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6697 16.0146H23.3496C23.5861 16.6621 23.7153 17.3608 23.7153 18.0891V26.8577C23.7153 27.1613 23.6624 27.4528 23.5663 27.7238H27.4019C28.8347 27.7238 30.0003 26.5581 30.0003 25.1254V20.3453C30.0004 17.9574 28.0576 16.0146 25.6697 16.0146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28507 18.0891C6.28507 17.3608 6.41427 16.6621 6.65075 16.0146H4.33067C1.94274 16.0146 0 17.9574 0 20.3453V25.1255C0 26.5582 1.16561 27.7239 2.5984 27.7239H6.43407C6.33792 27.4527 6.28507 27.1613 6.28507 26.8577V18.0891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6523 13.7588H12.3483C9.96032 13.7588 8.01758 15.7015 8.01758 18.0895V26.858C8.01758 27.3363 8.40535 27.7242 8.88371 27.7242H21.1168C21.5952 27.7242 21.983 27.3364 21.983 26.858V18.0895C21.983 15.7015 20.0402 13.7588 17.6523 13.7588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9992 2.27539C12.1274 2.27539 9.79102 4.61176 9.79102 7.48362C9.79102 9.43158 10.8662 11.1328 12.4539 12.0261C13.207 12.4497 14.0753 12.6918 14.9992 12.6918C15.9231 12.6918 16.7913 12.4497 17.5444 12.0261C19.1323 11.1328 20.2074 9.43152 20.2074 7.48362C20.2074 4.61182 17.871 2.27539 14.9992 2.27539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85401 7.12988C3.70625 7.12988 1.95898 8.87715 1.95898 11.0249C1.95898 13.1727 3.70625 14.9199 5.85401 14.9199C6.39882 14.9199 6.91761 14.8071 7.38888 14.6042C8.20368 14.2534 8.87552 13.6325 9.29124 12.8546C9.58304 12.3087 9.74904 11.6859 9.74904 11.0249C9.74904 8.87721 8.00177 7.12988 5.85401 7.12988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.145 7.12988C21.9973 7.12988 20.25 8.87715 20.25 11.0249C20.25 11.686 20.416 12.3088 20.7078 12.8546C21.1235 13.6325 21.7954 14.2535 22.6102 14.6042C23.0814 14.8071 23.6002 14.9199 24.145 14.9199C26.2928 14.9199 28.0401 13.1727 28.0401 11.0249C28.0401 8.87715 26.2928 7.12988 24.145 7.12988Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2579_7179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerWhiteIcon);
export default __webpack_public_path__ + "static/media/customerWhiteIcon.47451e6baa21d946c95830f97338c900.svg";
export { ForwardRef as ReactComponent };